import { getServerDate, matterQuery, getVillages, unauthorized} from "@/api/map/index";
export const mixin = {
  mounted() {
    this.getData()
    this.GetVillages()
    // setTimeout(() => {
    //   this.getMatterList()
    // }, 500);
    
  },
  methods: {
    // 获取服务器当前时间
    getData() {
      let obj={method:'/zwmap/getDate', body: ''}
      // getServerDate().then(res => {
      unauthorized(obj).then(res => {
        // console.log(res,'时间')
        if (res.data.code == 200) {
          this.FormatData(res.data.data)
        }
      })
    },
    // 获取乡镇列表
    GetVillages() {
      let obj={method:'/zwmap/getVillages', body: ''}
      // getVillages().then(res => {
      unauthorized(obj).then(res => {
        // console.log(res, '乡镇列表')
        if (res.status == 200) {
          if (res.data.data && res.data.data.length > 0) {
            let arrList = res.data.data;
            arrList.unshift({ type: null, hanyuanMaps:[ {id:"fa08802c1d4d11eda7660242ac120002"}], name: "县本级" });
            for (let index = 0; index < arrList.length; index++) {
              switch (arrList[index].name.slice(0, 2)) {
                case '县本':
                  arrList[index].url = 'HanYuan'
                  break;
                case '安乐':
                  arrList[index].url = 'AnLe'
                  break;
                case '大树':
                  arrList[index].url = 'DaShu'
                  break;
                case '富林':
                  arrList[index].url = 'FuLin'
                  break;
                case '富泉':
                  arrList[index].url = 'FuQuan'
                  break;
                case '富乡':
                  arrList[index].url = 'FuXiang'
                  break;
                case '富庄':
                  arrList[index].url = 'FuZhuang'
                  break;
                case '河南':
                  arrList[index].url = 'HeNan'
                  break;
                case '皇木':
                  arrList[index].url = 'HuangMu'
                  break;
                case '九襄':
                  arrList[index].url = 'JiuXiang'
                  break;
                case '马烈':
                  arrList[index].url = 'MaLie'
                  break;
                case '坭美':
                  arrList[index].url = 'NiMei'
                  break;
                case '片马':
                  arrList[index].url = 'PianMa'
                  break;
                case '前域':
                  arrList[index].url = 'QianYu'
                  break;
                case '清溪':
                  arrList[index].url = 'QingXi'
                  break;
                case '晒经':
                  arrList[index].url = 'ShaiJin'
                  break;
                case '顺河':
                  arrList[index].url = 'ShunHe'
                  break;
                case '唐家':
                  arrList[index].url = 'TangJia'
                  break;
                case '乌斯':
                  arrList[index].url = 'WuSiHe'
                  break;
                case '小堡':
                  arrList[index].url = 'XiaoBao'
                  break;
                case '富泉':
                  arrList[index].url = 'FuQuan'
                  break;
                case '宜东':
                  arrList[index].url = 'YiDong'
                  break;
                case '永利':
                  arrList[index].url = 'YongLi'
                  break;
                default:
                  break;
              }
            }
            // console.log(arrList,'结果')
            this.villages = arrList;
            let obj = this.villages.find(el => el.name == this.name);
            if (obj) {
              let ids = []
              obj.hanyuanMaps.forEach(el => {
                ids.push(el.id)
              });
              this.mapId = ids;
              if(this.name=='县本级'){
                sessionStorage.setItem('topTitle','汉源县政务服务中心' )
              }else{sessionStorage.setItem('topTitle', this.name)}
              
              sessionStorage.setItem('lifeCycleDetails', JSON.stringify({name: this.name, id:this.mapId}));
            }
          }
        } else {
          this.$message.error('获取乡镇列表失败！')
        }
      })
    },
    // 获取便民办事
    // getMatterList() {
    //   let ids=[]
    //   this.mapId.forEach(el => {
    //     ids.push(el.id)
    //   });
    //   let query = {
    //     ids
    //   };
    //   matterQuery(query).then(res => {
    //     // console.log(res,'事项列表')
    //     if (res.data.code == 200) {
    //       if (res.data.rows && res.data.rows.length > 0) {
    //         this.matterList = res.data.rows;
    //       } else {
    //         // this.$message.error('暂无事项！')
    //         console.log('暂无事项')
    //       }
    //     } else {
    //       this.$message.error('事项列表获取失败！')
    //     }
    //   })
    // },
    // 日期时间格式化
    FormatData(n) {
      // console.log(n, '时间')
      let now = new Date(n),
        // y = now.getFullYear();
        m = now.getMonth() + 1;
      // d = now.getDate();
      // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
      this.nowMoth = m;
    },
  },
}